import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const ContextTableWidget: WidgetRegistryEntry = {
  name: "ContextTable",
  configuration: () => import("./configuration").then((m) => m.ContextTableWidgetConfiguration),
  component: () => import("./context-table-widget.component").then((m) => m.ContextTableWidgetComponent)
};
